// frontend/src/components/dialogs/ResetTemplateDialog.js
import React from 'react';
import { RotateCcw, X, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import ConfirmDialogShell from './ConfirmDialogShell';

/**
 * Specialized dialog for resetting templates to global defaults
 * Uses the standardized ConfirmDialogShell with enhanced warning messaging
 */
const ResetTemplateDialog = ({
    isOpen,
    onClose,
    onConfirm,
    isResetting = false,
    templateType = 'template' // e.g., 'email template', 'SMS template'
}) => {
    const { t } = useTranslation();
    const { text, semantic, cn } = useTheme();

    return (
        <ConfirmDialogShell
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title={t('resetToGlobalTitle')}
            confirmLabel={t('resetToGlobal')}
            cancelLabel={t('Cancel')}
            confirmVariant="warning"
            confirmIcon={RotateCcw}
            cancelIcon={X}
            isLoading={isResetting}
            showIcon={true}
            iconVariant="warning"
            size="md"
        >
            <div className="space-y-4 text-center">
                {/* Primary warning message */}
                <div className={cn('p-4 rounded-lg border', semantic.warning)}>
                    <p className={cn('font-medium', text.primary)}>
                        ⚠️ {t('resetToGlobalWarning')}
                    </p>
                </div>

                {/* Consequence explanation */}
                <p className={cn('text-sm', text.secondary)}>
                    {t('resetToGlobalConsequence')}
                </p>

                {/* Additional context */}
                <div className={cn('text-xs p-3 rounded border-l-4 border-amber-400', semantic.warning)}>
                    <p className={cn('font-medium mb-1', text.primary)}>
                        {t('What happens next')}:
                    </p>
                    <ul className={cn('text-left space-y-1', text.secondary)}>
                        <li>• {t('Your custom')} {templateType} {t('will be deleted')}</li>
                        <li>• {t('Global default template will be restored')}</li>
                        <li>• {t('This action cannot be undone')}</li>
                    </ul>
                </div>
            </div>
        </ConfirmDialogShell>
    );
};

export default ResetTemplateDialog;